import { InjectionToken } from '@angular/core';

export interface AdvaniaVersioningConfig {
    checkOnInit: boolean;
    enableDebugLogging: boolean;
    pollIntervalInMs: number | null;
    onUpdateRequired: () => void;
    onUnrecoverable: () => void;
    onUpdateNow: () => void;
}

export type AdvaniaVersioningConfigInput = Partial<AdvaniaVersioningConfig> | (() => Partial<AdvaniaVersioningConfig>);

export const defaultAdvaniaVersioningConfig: AdvaniaVersioningConfig = {
    checkOnInit: true,
    enableDebugLogging: false,
    pollIntervalInMs: 5 * 60 * 1000,
    onUpdateRequired: () => undefined,
    onUnrecoverable: () => {
        window.location.reload();
    },
    onUpdateNow: () => {
        window.location.reload();
    },
};

export const ADVANIA_VERSIONING_CONFIG = new InjectionToken<AdvaniaVersioningConfig>('ADVANIA_VERSIONING_CONFIG', {
    providedIn: 'root',
    factory: () => defaultAdvaniaVersioningConfig,
});
